export const PRIVATE_PARTY_EVENTS = {
  WIDGET_VIEW: 'private-party.widget_view',
  SIGN_UP: 'private-party.sign_up',
  ENTER_PLATE_INPUT: 'private-party.license_plate_input',
  SELECT_STATE_INPUT: 'private-party.license_plate_state_input',
  VIN_INPUT: 'private-party.vin_input',
  LISTING_STYLE_SELECT: 'private-party.listing_style_select',
  STYLE_DECODE: 'private-party.create_style_decode',
  SUBMIT_VEHICLE_DETAILS: 'private-party.submit_vehicle_details',
  SUBMIT_SELLER_DESCRIPTION: 'private-party.submit_seller_description',
  SELECT_PHOTOS: 'private-party.select_photos',
  SELECT_PHOTOS_FILENAMES: 'private-party.select_photos_filenames',
  REMOVE_PHOTO: 'private-party.remove-photo',
  CONTINUE: 'private-party.continue',
  PHOTO_UPLOAD_SYSTEM_ERROR: 'private-party.photo-upload-system-error',
  PRICE_INPUT: 'private-party.price_input',
  SUBMIT_LISTING: 'private-party.submit_listing',
  MANAGE_LISTING: 'private-party.manage_listing',
  SELLER_INFO_INPUT: 'private-party.seller-info-input',
  WHY_NOT_APPROVED: 'private-party.why_not_approved',
  NOT_APPROVED_BUTTON: 'private-party.not_approved_button',
  API_SYSTEM_ERROR: 'private-party.api-system-error',
  SHARE_CONTENT: 'private-party.share-content',
  SUMMARY_CHECKOUT: 'private-party.summary-checkout',
  CREATE_DEAL: 'private-party.create-deal',
  START_PP_LISTING: 'private-party.start_pp_listing',
  LISTING_OWNER_ACTIONS: 'private-party.listing-owner-actions',
  LISTING_MORE_ACTIONS_BTN: 'private-party.listing-more-actions-btn',
  STATUS_RESULT: 'private-party.status_result',
  RENEW_LISTING: 'private-party.renew_listing',
  CREATE_LISTING_VEHICLE_DETAILS: 'private-party.private_party_create_listing_vehicle_details',
  OFFER_TRACKING: 'private-party.offer_tracking',
  VIEW_PARTNER_OFFER: 'private-party.view_partner_offer',
  EMO_PARTNER_TO_SOLICIT: 'private-party.emo_partner_to_solicit',
  DISPLAY_CONDITION_QUESTIONS: 'private-party.display_condition_questions',
  ZIP_EDIT_SUCCESS: 'private-party.zip_edit_success',
  DATA_PREFILLED: 'private-party.data_prefilled',
  OFFER_RENEWAL_ERROR: 'private-party.offer_renewal_error',
  MANAGE_EXISTING_LISTING: 'private-party.manage_existing_listing',
  ADD_SELLER_NOTES_TOGGLE: 'private-party.add_seller_notes_toggle',
  RETRIEVE_FROM_MODS_ID: 'private-party.retrieve_from_mods_id',
  UNABLE_RETRIEVE_FROM_MODS_ID: 'private-party.unable_retrieve_from_mods_id',
  TAB_SELECT: 'private-party.table_select',
  SELECT_SELLING_METHOD: 'private-party.select_selling_method',
  SOLD_TO_OTHER_SELECT: 'private-party.sold-to-other-select',
  SUBMIT_FEEDBACK_CLICK: 'private-party.submit-feedback-click',
  EXPAND_PARTNER_OFFER: 'private-party.expand_partner_offer',
  VIEW_PARTNER_OFFER_ACTION: 'private-party.view_partner_offer_action',
  PARTNER_OFFER_DISPLAYED: 'private-party.partner_offer_displayed',
  PARTNER_OFFER_VALUE: 'private-party.partner_offer_value',
  CHECKOUT_LISTING: 'private-party.checkout_listing',
  STRIPE_PAYMENT_SUCCESS: 'private-party.stripe_payment_success',
  SUBMIT_LISTING_FOR_APPROVAL: 'private-party.submit_for_approval',
  BUY_PRIVATE_PARTY: 'private-party.buy_private_party',
  TRANSMISSION_TYPE_SOURCE: 'private-party.transmission_type_source',
  DEACTIVATION_SURVEY_SELECT_REASON: 'private-party.deactivation_survey_select_reason',
  DEACTIVATION_SURVEY_SUBMIT_OTHER: 'private-party.deactivation_survey_submit_other',
  DEACTIVATION_SURVEY_CLOSE: 'private-party.deactivation_survey_close',
  DEACTIVATION_SURVEY_SELECT_HOW_SOLD: 'private-party.deactivation_survey_select_how_sold',
  DEACTIVATION_SURVEY_SUBMIT_FEEDBACK: 'private-party.deactivation_survey_submit_feedback',
  SEND_MESSAGE: 'private-party.send_message',
  SEND_MESSAGE_SUCCEEDED: 'private-party.send_message_succeeded',
  SEND_MESSAGE_FAILED: 'private-party.send_message_failed',
  CONTACT_FORM_TAB_TOGGLE: 'private-party.contact_form_tab_toggle',
  VALUE_FRAMING: 'private-party.value_framing',
};
